import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots } from "vue"

import { computed } from 'vue';

import FieldHistoryBtn from 'SharedComponents/Fields/FieldHistoryBtn.vue';
import {
  BaseFieldEmits,
  ValuedFieldProps,
  defaultValuedProps,
  useBaseFieldProps,
} from 'SharedComponents/Fields/composables/useBaseFieldProps';
import useFieldParams from 'SharedComponents/Fields/composables/useFieldParams';
import { useTooltip } from 'SharedComponents/Fields/composables/useFieldTooltip';
import SInput from 'SharedComponents/ui/Input/SInput.vue';
import Tooltip from 'SharedComponents/ui/Tooltip.vue';
import useValidation, { ValidationRule } from 'SharedDir/common/composables/useValidation';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { FieldValue, TextFieldParams } from 'SharedDir/declarations/fields';

type TextFieldProps = ValuedFieldProps &
  PropValue<FieldValue<null | string>> & {
    suffix: { shortName: string } | null;
    params: TextFieldParams;
    regexp?: string;
    regexpMessage?: string;
  };


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'TextField' },
  __name: 'TextField',
  props: /*@__PURE__*/_mergeDefaults({
    readonly: { type: Boolean },
    disable: { type: Boolean },
    required: { type: Boolean },
    useWrapper: { type: Boolean },
    skipValidation: { type: Boolean },
    errorMessage: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    modelValue: {},
    suffix: {},
    params: {},
    regexp: {},
    regexpMessage: {}
  }, {
  ...defaultValuedProps,
  suffix: () => ({ shortName: '' }),
}),
  emits: ["update:modelValue", "reveal-history"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const { innerValue, emitValue } = useValue(props, emit);

const { MaxLength, MinLength, CheckRegex } = useValidation();

const customRules = computed(() => {
  const rules: Array<ValidationRule> = [];
  if (props.params.minLength) {
    rules.push(MinLength(props.params.minLength));
  }
  if (props.params.maxLength) {
    rules.push(MaxLength(props.params.maxLength));
  }
  if (props.regexp) {
    rules.push(CheckRegex(props.regexp, props.regexpMessage));
  }
  return rules;
});

const { params, validationRules } = useFieldParams<TextFieldParams>(props, { customRules });

const { validationErrorStatus, hasHistory, revealHistory } = useBaseFieldProps(props, emit);

const tooltip = useTooltip(props);

const suffixCheck = computed(() => (props.suffix?.shortName ? props.suffix.shortName : ''));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SInput, {
    ref: "input",
    modelValue: _unref(innerValue).value,
    "onUpdate:modelValue": [
      _cache[1] || (_cache[1] = ($event: any) => ((_unref(innerValue).value) = $event)),
      _unref(emitValue)
    ],
    label: _ctx.label,
    clearable: "",
    outlined: "",
    dense: "",
    class: _normalizeClass({ 's-form-input_wrapper': _ctx.useWrapper }),
    "hide-bottom-space": "",
    required: _ctx.required,
    readonly: _ctx.readonly,
    disable: _ctx.disable,
    placeholder: _unref(params).placeholder ? _unref(params).placeholder : '',
    rules: _unref(validationRules),
    "bottom-slots": "",
    error: _unref(validationErrorStatus),
    "error-message": _ctx.errorMessage,
    suffix: suffixCheck.value
  }, _createSlots({ _: 2 }, [
    (_unref(tooltip) || (_ctx.showHistory && _unref(hasHistory)))
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            (_unref(tooltip))
              ? (_openBlock(), _createBlock(Tooltip, {
                  key: 0,
                  text: _unref(tooltip)
                }, null, 8, ["text"]))
              : _createCommentVNode("", true),
            (_ctx.showHistory && _unref(hasHistory))
              ? (_openBlock(), _createBlock(FieldHistoryBtn, {
                  key: 1,
                  history: _ctx.history,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(revealHistory)(_ctx.label)))
                }, null, 8, ["history"]))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "label", "class", "required", "readonly", "disable", "placeholder", "rules", "error", "error-message", "suffix", "onUpdate:modelValue"]))
}
}

})